import { combineReducers } from 'redux';
import savedFundsReducer from './saved-funds';
import fundStoreReducer from './fund-store';

export default combineReducers({
  savedFunds: savedFundsReducer,
  store: fundStoreReducer,
});
